import React from "react";
import styled from "@emotion/styled";
import ReportCard from "./ReportCard";
import CheckNutritionSection from "./CheckNutritionSection";
import { useReportMonk } from "../../context/reportMonk";
import { ReportsContainer } from "./shareStyledComponents";
import { toNumberFormat } from "../../utils/numberFormat";

const WeekResult = () => {
  const { getCurrentWeekRank, getCurrentWeekInform } = useReportMonk();
  return (
    <>
      <RankingContainer>
        <RankingLabel>Ranking</RankingLabel>
        <RankingCardContainer>
          <RankingCard>
            <RankingCardInnerContainer>
              <RankingHeader>ระดับห้อง</RankingHeader>
              <br />
              <RankingData>
                {toNumberFormat(getCurrentWeekRank("allRoom", "-"))}
              </RankingData>
            </RankingCardInnerContainer>
          </RankingCard>
          <RankingCard>
            <RankingCardInnerContainer>
              <RankingHeader>ระดับชั้น</RankingHeader>
              <br />
              <RankingData>
                {toNumberFormat(getCurrentWeekRank("allLevel", "-"))}
              </RankingData>
            </RankingCardInnerContainer>
          </RankingCard>
          <RankingCard>
            <RankingCardInnerContainer>
              <RankingHeader>ระดับโรงเรียน</RankingHeader>
              <br />
              <RankingData>
                {toNumberFormat(getCurrentWeekRank("allSchool", "-"))}
              </RankingData>
            </RankingCardInnerContainer>
          </RankingCard>
        </RankingCardContainer>
      </RankingContainer>

      <ReportsContainer>
        <ReportCard
          title="ดื่มดีนมวัว"
          total={toNumberFormat(
            getCurrentWeekInform("totalMilkVolume", 0) +
              getCurrentWeekInform("totalSoyMilkVolume", 0)
          )}
          prefix="บริโภค"
          unit="ml"
          score={toNumberFormat(getCurrentWeekInform("totalCowMilkScore", 0))}
        />
        <RankTextContainer>
          <span style={{ marginLeft: "8px" }}>
            Rank ระดับห้อง :{" "}
            {toNumberFormat(getCurrentWeekRank("cowMilkRoom", "-"))}
          </span>
          <span style={{ marginRight: "8px" }}>
            Rank ระดับชั้น :{" "}
            {toNumberFormat(getCurrentWeekRank("cowMilkLevel", "-"))}
          </span>
        </RankTextContainer>
        <ReportCard
          title="สุขชัวร์ เพิ่มผัก"
          total={toNumberFormat(
            getCurrentWeekInform("totalVegetableQuantity", 0)
          )}
          prefix="บริโภค"
          unit="ช้อนโต๊ะ"
          score={toNumberFormat(getCurrentWeekInform("totalVegetableScore", 0))}
        />
        <RankTextContainer>
          <span style={{ marginLeft: "8px" }}>
            Rank ระดับห้อง :{" "}
            {toNumberFormat(getCurrentWeekRank("vegetableRoom", "-"))}
          </span>
          <span style={{ marginRight: "8px" }}>
            Rank ระดับชั้น :{" "}
            {toNumberFormat(getCurrentWeekRank("vegetableLevel", "-"))}
          </span>
        </RankTextContainer>
        <ReportCard
          title="รัก ออกกำลัง"
          total={toNumberFormat(
            getCurrentWeekInform("totalExerciseMinutes", 0)
          )}
          unit="นาที"
          prefix="เวลา"
          score={getCurrentWeekInform("totalExerciseScore", 0)}
        />
        <RankTextContainer>
          <span style={{ marginLeft: "8px" }}>
            Rank ระดับห้อง :{" "}
            {toNumberFormat(getCurrentWeekRank("exerciseRoom", "-"))}
          </span>
          <span style={{ marginRight: "8px" }}>
            Rank ระดับชั้น :{" "}
            {toNumberFormat(getCurrentWeekRank("exerciseLevel", "-"))}
          </span>
        </RankTextContainer>
        <ReportCard
          title="หยุดยั้ง น้ำหวาน"
          total={toNumberFormat(
            getCurrentWeekInform("totalSweetDrinkVolume", 0)
          )}
          prefix="บริโภค น้ำหวาน"
          unit="ml"
          score={getCurrentWeekInform("totalSweetDrinkScore", 0)}
        />
        <RankTextContainer>
          <span style={{ marginLeft: "8px" }}>
            Rank ระดับห้อง :{" "}
            {toNumberFormat(getCurrentWeekRank("sweetDrinkRoom", "-"))}
          </span>
          <span style={{ marginRight: "8px" }}>
            Rank ระดับชั้น :{" "}
            {toNumberFormat(getCurrentWeekRank("sweetDrinkLevel", "-"))}
          </span>
        </RankTextContainer>
      </ReportsContainer>
      <CheckNutritionSection
        data={getCurrentWeekInform("nutritionStatus", {
          weight: "-",
          height: "-",
          weightForHeight: "-",
          heightForAge: "-",
        })}
      ></CheckNutritionSection>
    </>
  );
};

const RankTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #4b5768;
`;

const RankingContainer = styled.div`
  font-family: "Noto Sans", "Noto Sans Thai";
`;

const RankingCardContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 16px;
`;

const RankingCard = styled.div`
  background-color: #058459;
  width: calc((440px - 16px) / 3);
  text-align: center;
  border-radius: 8px;
  color: #ffffff;
`;

const RankingCardInnerContainer = styled.div`
  padding-top: 14px;
  padding-bottom: 14px;
`;

const RankingHeader = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  /* identical to box height, or 162% */

  text-align: center;

  /* Neutral / 600 */
`;

const RankingData = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */

  text-align: center;

  /* Neutral / 600 */
`;

const RankingLabel = styled.span`
  margin-left: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  /* identical to box height, or 144% */

  /* Primary/Green 500 */

  color: #058459;
  margin-bottom: 24px;
`;

export default WeekResult;
